import React from 'react';
import { Services } from '../components/Services';
import { Calendar, Phone } from 'lucide-react';
export function ServicesPage() {
  return <div className="pt-32" data-id="element-320">
      <div className="bg-slate-900 py-20 text-center" data-id="element-321">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-322">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-323">
            Our Specialized Services
          </h1>
          <p className="text-slate-400 text-xl max-w-2xl mx-auto" data-id="element-324">
            Providing non-emergency transportation solutions tailored to our
            clients’ unique needs across Charlotte and surrounding areas.
          </p>
        </div>
      </div>

      <Services data-id="element-325" />

      <section className="py-20 bg-blue-50" data-id="element-326">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-327">
          <div className="bg-white rounded-3xl p-8 md:p-16 shadow-2xl flex flex-col md:flex-row items-center justify-between gap-12" data-id="element-328">
            <div className="max-w-xl" data-id="element-329">
              <h2 className="text-3xl font-bold text-slate-900 mb-6" data-id="element-330">
                Need a custom transportation plan?
              </h2>
              <p className="text-slate-600 text-lg mb-0" data-id="element-331">
                We offer flexible scheduling for one-way or round-trip rides.
                Whether it's a daily medical appointment or a one-time social
                event, we've got you covered.
              </p>
            </div>
            <div className="flex flex-col sm:flex-row gap-4 w-full md:w-auto" data-id="element-332">
              <button className="bg-blue-600 text-white px-8 py-4 rounded-xl font-bold hover:bg-blue-700 transition-all shadow-lg" data-id="element-333">
                Book a Ride
              </button>
              <a href="tel:7040000000" className="bg-white border-2 border-slate-200 text-slate-900 px-8 py-4 rounded-xl font-bold text-center hover:border-blue-600 hover:text-blue-600 transition-all" data-id="element-334">
                Call Now
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>;
}